import { copyTextToClipboard } from '@/utils/clipboard.utils';
import { useUi } from './use-ui';
import { AlertType } from '@/interfaces/IAlert';

export function useClipboard() {
  const ui = useUi();

  async function copyText(text: string) {
    try {
      await copyTextToClipboard(text);
      ui.showToast(AlertType.Success, 'Texto copiado');
    } catch (err) {
      ui.showToast(AlertType.Error, 'No se pudo copiar el texto');
    }
  }

  return {
    copyText,
  };
}
